const getRootElement = () => document.getElementById("root");

const getRuntimeConfig = () => {
  const rootElement = getRootElement();

  return {
    id: window.wpData?.id || rootElement?.dataset.paramId || null,
    theme:
      window.wpData?.theme ||
      rootElement?.dataset.theme ||
      process.env.REACT_APP_THEME ||
      "theme-ped",
    apiBase:
      window.wpData?.apiBase ||
      rootElement?.dataset.apiBase ||
      process.env.REACT_APP_API ||
      "",
  };
};

const getApiBase = () => getRuntimeConfig().apiBase;
const getTheme = () => getRuntimeConfig().theme;
const getConfiguratorId = () => getRuntimeConfig().id;

export { getRuntimeConfig, getApiBase, getTheme, getConfiguratorId };
